import PropTypes from 'prop-types'

export const MessageChat = ({ user, sender_email, content, date }) => {

  const validateFromIs = (email) => {

    return email === (user?.email ? user.email.replace('@', '-').replace('.', '-') : '');
  }

  return (
    <div className={"text-left message_item " +
      (validateFromIs(sender_email) ? 'place-self-end' : 'place_to_start')}>
      <div className={"pl-2 pr-2 pt-2 rounded-2xl break-all " +
        (validateFromIs(sender_email) ? 'message_right_color' : 'message_left_color')}>
        <span>{content}</span> <br />
        <small style={{fontSize:'8px'}}>{date}</small>
      </div>
    </div>
  );
};


MessageChat.propTypes = {
    sender_email: PropTypes.string,
    content: PropTypes.string,
    date: PropTypes.string,
    user: PropTypes.object
}